<template>
  <div>
    <div class="row">
      <div class="col-12 mb-1" align="right">
        <button class="btn btn-add" @click="importarLinhaCuidados()">
          Importar Linhas de Cuidados do SIGAP
        </button>
      </div>
      <div class="col-md-12">
        <base-crud
          :ref="'careLinesCrud'"
          crudName="Linha de Cuidados"
          newText="Nova Linha de Cuidado"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "outcomeTable",
      showMessageImport: false,
      careLinesCrud: {},
      pages: [],
      url: "",
      columns: ["id", "title", "description", "actions"],
      tableData: ["id", "title", "description"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "title", "description"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          title: "Nome",
          description: "Descrição",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [""];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "care_lines",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    importarLinhaCuidados: function () {
      const self = this;
      const api = self.$store.state.api + "care-lines-from-sigap/";

      self.$loading(true);
      axios
        .get(api)
        .then(() => {
          self.$loading(false);
          self.$message(
            "Sucesso",
            "Linhas de Cuidados importadas com sucesso",
            "success"
          );
          self.reload++;
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    query: function (query) {
      let columns = {
        id: "id",
        title: "title",
        description: "description",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>